import React, { useEffect, useState } from 'react';
import styles from './PropertyProduct.module.scss';
import { useLocation } from 'react-router-dom';
import useUsers from '../../hooks/useUsers';
import ProductCard from '../ProductCard/ProductCard';

export default function ProductProperties() {
    const { getProducts } = useUsers();

    const [loading, setLoading] = useState(true);

    const [metadata, setMetadata] = useState({
        offset: 0,
        limit: 10,
    });

    const [total, setTotal] = useState(null);

    const [propertyProducts, setPropertyProducts] = useState([]);

    const location = useLocation();

    const fetchData = () => {
        getProducts(
            location?.state?.myFilters || {},
            metadata.offset,
            metadata.limit,
            ''
        ).then((data) => {
            if (data.data) {
                setTotal(data.data.total);
                setLoading(false);
                setPropertyProducts([...propertyProducts, ...data.data.products]);
            }
        });
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.wrapper}>
            {propertyProducts.map((product) => (
                <ProductCard
                    key={product.id}
                    id={product.id}
                    products_type="Traktor"
                    product={product}
                    name={product.name}
                    stock_status={product.stock_status}
                    files={product.files}
                    price={product.price_with_subsidy}
                    old_price={product.old_price}
                    is_active={product.is_active}
                    navigation={product.navigation}
                    calc_type={product.calc_type}
                    leasing_amount={product.leasing_amount}
                    monthly_payment_amount={product?.monthly_payment_amount}
                    singlePageCards={false}
                />
            ))}
        </div>
    );
}
